<script lang="ts">
  import Modal from './Modal.svelte';

  interface Props {
    title: string;
    message: string;
    danger?: boolean;
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
  }
  let {
    title,
    message,
    danger = false,
    open,
    onClose,
    onConfirm,
  }: Props = $props();
</script>

<Modal {open} {onClose}>
  <h2 class="modal-title">{title}</h2>
  <p class="modal-message">{message}</p>
  <div class="modal-actions">
    <button class="btn secondary" onclick={onClose}> Avbryt </button>
    <button
      class={['btn', danger ? 'danger' : 'success']}
      onclick={() => {
        onConfirm();
        onClose();
      }}
    >
      Bekreft
    </button>
  </div>
</Modal>

<style>
  .modal-title {
    font-size: 1rem;
    font-weight: 700;
    color: var(--text);
    margin: 0 0 0.5rem;
    padding-inline-end: 2rem;
  }

  .modal-message {
    font-size: 0.875rem;
    color: var(--text-muted);
    margin: 0 0 1.5rem;
  }

  .modal-actions {
    display: flex;
    gap: 0.5rem;
    justify-content: flex-end;
    width: 100%;
  }
</style>
